import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import { jsonResponse, sendJson } from 'fetch-utilities';

var PENDING = 'store/addresses/PENDING';
var LOADING = 'store/addresses/LOADING';
var LOADED = 'store/addresses/LOADED';
var ERROR = 'store/addresses/ERROR';

var CREATED = 'store/addresses/CREATED';
var UPDATED = 'store/addresses/UPDATED';
var REMOVED = 'store/addresses/REMOVED';

var initialState = {
  state: PENDING,
  lastEvent: null,
  data: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
      return _extends({}, state, {
        lastEvent: action.event || null,
        state: action.type
      });

    case LOADED:
    case CREATED:
    case UPDATED:
    case REMOVED:
      return _extends({}, state, {
        state: action.error ? ERROR : action.type,
        lastEvent: action.event || null,
        error: action.error,
        data: action.error ? state.data : action.payload || initialState.data,
        errorData: action.error ? action.payload : null,
        loggedIn: !action.error && action.payload ? true : false
      });

    default:
      return state;
  }
}

var load = function load() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      payload: client('/customer/addresses').then(jsonResponse).catch(function (err) {
        return !err.httpOk && err.httpStatus === 403 ? null : _Promise.reject(err);
      })
    });
  };
};

var create = function create(data) {
  return function (dispatch, _getState, client) {
    console.log(data);
    dispatch({
      type: LOADING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      event: CREATED,
      payload: client('/customer/addresses', sendJson({ method: 'POST', body: data })).then(function () {
        return client('/customer/addresses/');
      }).then(jsonResponse)
    });
  };
};

var update = function update(data) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      event: UPDATED,
      payload: client("/customer/addresses/" + data.id, sendJson({ method: 'PUT', body: data })).then(function () {
        return client('/customer/addresses/');
      }).then(jsonResponse)
    });
  };
};

var remove = function remove(id) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      event: REMOVED,
      payload: client("/customer/addresses/" + id, sendJson({ method: 'DELETE' })).then(function () {
        return client('/customer/addresses/');
      }).then(jsonResponse)
    });
  };
};

export { PENDING, LOADING, LOADED, ERROR, CREATED, UPDATED, REMOVED, load, create, update, remove };
export default reducer;
